var chunkToChildrenMap = {
	"25284": [
		1271,
		22195,
		43011,
		37717,
		5444
	],
	"77195": [
		5444
	],
	"78319": [
		1271,
		22195,
		43011,
		37717,
		5444
	],
	"79410": [
		5444
	],
	"95896": [
		5444
	],
	"99524": [
		1271,
		22195,
		43011,
		37717,
		5444
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));